import { NavLink, Outlet, Navigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Layers, SlidersHorizontal, ShieldCheck, Settings2, Sun, Users, Bell, Lock } from 'lucide-react';

export default function Settings() {
  const { t } = useTranslation('settings');

  return (
    <div className="page-enter" style={{ display: 'flex', gap: 'var(--space-8)', alignItems: 'flex-start' }}>
      {/* Settings sidebar */}
      <aside style={{
        width: 200, flexShrink: 0,
        border: '1px solid var(--color-border)', borderRadius: 'var(--radius-lg)',
        overflow: 'hidden',
      }}>
        <div style={{
          padding: 'var(--space-3) var(--space-4)',
          borderBottom: '1px solid var(--color-border)',
          background: 'var(--color-bg-subtle)',
        }}>
          <p style={{ fontSize: 'var(--text-xs)', fontWeight: 'var(--font-medium)', color: 'var(--color-text-muted)', textTransform: 'uppercase', letterSpacing: '0.05em' }}>
            {t('title')}
          </p>
        </div>
        <nav style={{ padding: 'var(--space-2)' }}>
          {[
            { to: '/settings/workspace', label: t('nav.workspace'), icon: <Settings2 size={15} /> },
            { to: '/settings/appearance', label: t('nav.appearance'), icon: <Sun size={15} /> },
            { to: '/settings/members', label: t('nav.members'), icon: <Users size={15} /> },
            { to: '/settings/notifications', label: t('nav.notifications'), icon: <Bell size={15} /> },
            { to: '/settings/security', label: t('nav.security'), icon: <ShieldCheck size={15} /> },
            { to: '/settings/mfa', label: '2FA', icon: <Lock size={15} /> },
            { to: '/settings/stages', label: t('nav.stages'), icon: <Layers size={15} /> },
            { to: '/settings/custom-fields', label: t('nav.custom_fields'), icon: <SlidersHorizontal size={15} /> },
            { to: '/settings/validation-rules', label: t('nav.validation_rules'), icon: <ShieldCheck size={15} /> },
          ].map(({ to, label, icon }) => (
            <NavLink
              key={to}
              to={to}
              style={({ isActive }) => ({
                display: 'flex', alignItems: 'center', gap: 'var(--space-2)',
                padding: 'var(--space-2) var(--space-3)',
                borderRadius: 'var(--radius-md)', fontSize: 'var(--text-sm)',
                color: isActive ? 'var(--color-brand)' : 'var(--color-text-secondary)',
                background: isActive ? 'var(--color-brand-pale)' : 'none',
                fontWeight: isActive ? 'var(--font-medium)' : undefined,
                textDecoration: 'none',
              })}
            >
              {icon}
              {label}
            </NavLink>
          ))}
        </nav>
      </aside>

      {/* Content area */}
      <div style={{ flex: 1, minWidth: 0 }}>
        <Outlet />
      </div>
    </div>
  );
}

export function SettingsIndex() {
  return <Navigate to="/settings/workspace" replace />;
}
